"use client";

import { Award, CircleCheck, ShieldCheck } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TrustSignals() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const badges = [{
    icon: ShieldCheck,
    label: "Lands Commission Verified",
    ref: ref1,
    isVisible: isVisible1
  }, {
    icon: CircleCheck,
    label: "US-Managed Escrow",
    ref: ref2,
    isVisible: isVisible2
  }, {
    icon: Award,
    label: "Diaspora Vetted",
    ref: ref3,
    isVisible: isVisible3
  }];
  return <section id="trust-signals" className="py-16 bg-light-background">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12">
          {badges.map((badge, i) => {
          const Icon = badge.icon;
          return <div key={i} data-index={i} ref={badge.ref} className={`flex flex-col items-center text-center gap-3 group transition-opacity duration-[var(--duration-medium)] ${badge.isVisible ? "opacity-100" : "opacity-0"}`} style={{
            transform: badge.isVisible ? "translateY(0)" : "translateY(1rem)",
            transitionProperty: "opacity, transform",
            transitionDuration: "var(--duration-medium)",
            transitionTimingFunction: "var(--ease-smooth)"
          }}>
                <Icon className="w-12 h-12 text-accent-dark transition-transform duration-[var(--duration-fast)] ease-[var(--ease-smooth)] group-hover:scale-105" strokeWidth={1.5} />
                <span className="text-sm font-semibold text-foreground-light relative inline-block">
                  {badge.label}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:w-full"></span>
                </span>
              </div>;
        })}
        </div>
      </div>
    </section>;
}